const textileViewStyles = (theme) => ({
  textWrapper: {
    "& pre": {
      margin: "1em 1em 1em 1em",
      padding: 8,
      backgroundColor: "#fafafa",
      border: "1px solid #e2e2e2",
      borderRadius: 3,
      width: "auto",
      overflowX: "auto",
      overflowY: "hidden",
    },
  },
});

export default textileViewStyles;
